export default "__VITE_ASSET__C65pfRuo__"